var map = {
	"./de/CardsBenefitsJune2025LP.json": [
		12542,
		12542
	],
	"./de/QuizBonusJune2025LP.json": [
		33389,
		33389
	],
	"./de/aviatorup.json": [
		77870,
		77870
	],
	"./de/banksBenefitsMay2025.json": [
		24464,
		24464
	],
	"./de/becomeVip.json": [
		5481,
		5481
	],
	"./de/bigBass.json": [
		4809,
		4809
	],
	"./de/blackWheelLP.json": [
		14866,
		14866
	],
	"./de/bonanzaPromo.json": [
		86363,
		28509
	],
	"./de/bonusClaimLP.json": [
		52543,
		52543
	],
	"./de/bonuses.json": [
		57425,
		57425
	],
	"./de/buffaloWheel.json": [
		33913,
		33913
	],
	"./de/carways2025LP.json": [
		53191,
		53191
	],
	"./de/cashbox.json": [
		20008,
		20008
	],
	"./de/cashupBonanza.json": [
		64422,
		64422
	],
	"./de/centredRegFormLP.json": [
		37486,
		37486
	],
	"./de/circleLP.json": [
		10374,
		10374
	],
	"./de/circusNovember.json": [
		7102,
		7102
	],
	"./de/common.json": [
		21545,
		21545
	],
	"./de/crownApril25.json": [
		61674,
		61674
	],
	"./de/crownBanner.json": [
		37049,
		37049
	],
	"./de/crownMarch25.json": [
		15367,
		15367
	],
	"./de/crownWheelBlack.json": [
		87364,
		87364
	],
	"./de/crownWheelBlackLP.json": [
		73047,
		73047
	],
	"./de/cryptoExclusiveMay25LP.json": [
		22669,
		22669
	],
	"./de/cryptoOfferMay25LP.json": [
		84039,
		84039
	],
	"./de/deposits.json": [
		47058,
		47058
	],
	"./de/dialogs.json": [
		20435,
		20435
	],
	"./de/diceRoll.json": [
		29446,
		39849
	],
	"./de/dogTreasure.json": [
		94370,
		94370
	],
	"./de/dogTreasureTerms.json": [
		54019,
		54019
	],
	"./de/easterApril2025.json": [
		47656,
		47656
	],
	"./de/easterMissions.json": [
		47479,
		47479
	],
	"./de/fiestaJune25LP.json": [
		83134,
		83134
	],
	"./de/fruitsupMarch25.json": [
		30522,
		30522
	],
	"./de/gatesOfOlympusLP.json": [
		98599,
		98599
	],
	"./de/glossary.json": [
		60365,
		60365
	],
	"./de/history.json": [
		19883,
		19883
	],
	"./de/jackpot.json": [
		15512,
		15512
	],
	"./de/juicyCarMay2025.json": [
		50745,
		50745
	],
	"./de/juicyMay.json": [
		29862,
		29862
	],
	"./de/leaveDeposit.json": [
		93829,
		93829
	],
	"./de/leaveRegistration.json": [
		55280,
		55280
	],
	"./de/limits.json": [
		92774,
		92774
	],
	"./de/lobby.json": [
		55868,
		55868
	],
	"./de/lootboxes.json": [
		71458,
		71458
	],
	"./de/loyalty.json": [
		67563,
		67563
	],
	"./de/lpAssets.json": [
		17133,
		17133
	],
	"./de/lyzer40BanksBenefitsJune2025LP.json": [
		96371,
		96371
	],
	"./de/march2025.json": [
		3606,
		3606
	],
	"./de/mobileApp.json": [
		35865,
		35865
	],
	"./de/personal.json": [
		9397,
		9397
	],
	"./de/profile.json": [
		24234,
		24234
	],
	"./de/promotions.json": [
		71597,
		71597
	],
	"./de/referralSystem.json": [
		18377,
		18377
	],
	"./de/regDragonRewards.json": [
		19177,
		19177
	],
	"./de/regDragonRewardsAugust25LP.json": [
		32736,
		32736
	],
	"./de/regRewards.json": [
		76626,
		76626
	],
	"./de/scratchGame.json": [
		81809,
		81809
	],
	"./de/security.json": [
		95345,
		95345
	],
	"./de/sharkJuly25LP.json": [
		93893,
		93893
	],
	"./de/slotsCircle.json": [
		3550,
		3550
	],
	"./de/sportsDeposit.json": [
		52219,
		52219
	],
	"./de/sunOfEgypt.json": [
		5559,
		5559
	],
	"./de/support.json": [
		95774,
		95774
	],
	"./de/turbolvlJuly25LP.json": [
		15179,
		15179
	],
	"./de/validation.json": [
		15399,
		15399
	],
	"./de/verification.json": [
		44050,
		44050
	],
	"./de/vip.json": [
		84259,
		84259
	],
	"./de/vipGemCards.json": [
		78908,
		78908
	],
	"./de/welcomeApril2025.json": [
		70984,
		70984
	],
	"./de/wheel.json": [
		30587,
		30587
	],
	"./de/wheelFortuneLP.json": [
		82900,
		82900
	],
	"./de/winterJanuary.json": [
		38746,
		3353
	],
	"./de/withdraw.json": [
		90066,
		90066
	],
	"./de/wolfElvisSunBuffalo.json": [
		26806,
		26806
	],
	"./de/wolfWheelLP.json": [
		83210,
		83210
	],
	"./en-AU/CardsBenefitsJune2025LP.json": [
		89450,
		89450
	],
	"./en-AU/QuizBonusJune2025LP.json": [
		885,
		885
	],
	"./en-AU/aviatorup.json": [
		33259,
		33259
	],
	"./en-AU/banksBenefitsMay2025.json": [
		50825,
		50825
	],
	"./en-AU/becomeVip.json": [
		25313,
		25313
	],
	"./en-AU/bigBass.json": [
		81467,
		81467
	],
	"./en-AU/blackWheelLP.json": [
		61379,
		61379
	],
	"./en-AU/bonanzaPromo.json": [
		41267,
		41267
	],
	"./en-AU/bonusClaimLP.json": [
		4610,
		4610
	],
	"./en-AU/bonuses.json": [
		96644,
		96644
	],
	"./en-AU/buffaloWheel.json": [
		16900,
		16900
	],
	"./en-AU/carways2025LP.json": [
		67828,
		67828
	],
	"./en-AU/cashbox.json": [
		39183,
		39183
	],
	"./en-AU/cashupBonanza.json": [
		88553,
		88553
	],
	"./en-AU/centredRegFormLP.json": [
		63182,
		63182
	],
	"./en-AU/circleLP.json": [
		72201,
		72201
	],
	"./en-AU/circusNovember.json": [
		12701,
		12701
	],
	"./en-AU/common.json": [
		49486,
		49486
	],
	"./en-AU/crownApril25.json": [
		42011,
		42011
	],
	"./en-AU/crownBanner.json": [
		61036,
		61036
	],
	"./en-AU/crownMarch25.json": [
		3767,
		3767
	],
	"./en-AU/crownWheelBlack.json": [
		50691,
		50691
	],
	"./en-AU/crownWheelBlackLP.json": [
		8228,
		8228
	],
	"./en-AU/cryptoExclusiveMay25LP.json": [
		5643,
		5643
	],
	"./en-AU/cryptoOfferMay25LP.json": [
		20476,
		20476
	],
	"./en-AU/deposits.json": [
		90908,
		90908
	],
	"./en-AU/dialogs.json": [
		92999,
		92999
	],
	"./en-AU/diceRoll.json": [
		64255,
		64255
	],
	"./en-AU/dogTreasure.json": [
		84317,
		84317
	],
	"./en-AU/dogTreasureTerms.json": [
		72390,
		72390
	],
	"./en-AU/easterApril2025.json": [
		4004,
		4004
	],
	"./en-AU/easterMissions.json": [
		32644,
		32644
	],
	"./en-AU/fiestaJune25LP.json": [
		80974,
		80974
	],
	"./en-AU/fruitsupMarch25.json": [
		22692,
		22692
	],
	"./en-AU/gatesOfOlympusLP.json": [
		60795,
		60795
	],
	"./en-AU/glossary.json": [
		27516,
		27516
	],
	"./en-AU/history.json": [
		31436,
		31436
	],
	"./en-AU/jackpot.json": [
		6551,
		6551
	],
	"./en-AU/juicyCarMay2025.json": [
		1722,
		1722
	],
	"./en-AU/juicyMay.json": [
		75174,
		75174
	],
	"./en-AU/leaveDeposit.json": [
		60509,
		60509
	],
	"./en-AU/leaveRegistration.json": [
		29106,
		29106
	],
	"./en-AU/limits.json": [
		11039,
		11039
	],
	"./en-AU/lobby.json": [
		46593,
		46593
	],
	"./en-AU/lootboxes.json": [
		50583,
		50583
	],
	"./en-AU/loyalty.json": [
		79297,
		79297
	],
	"./en-AU/lpAssets.json": [
		78752,
		78752
	],
	"./en-AU/lyzer40BanksBenefitsJune2025LP.json": [
		99722,
		99722
	],
	"./en-AU/march2025.json": [
		44049,
		44049
	],
	"./en-AU/mobileApp.json": [
		4575,
		4575
	],
	"./en-AU/personal.json": [
		90273,
		90273
	],
	"./en-AU/profile.json": [
		24784,
		24784
	],
	"./en-AU/promotions.json": [
		16233,
		16233
	],
	"./en-AU/referralSystem.json": [
		46806,
		46806
	],
	"./en-AU/regDragonRewards.json": [
		51899,
		51899
	],
	"./en-AU/regDragonRewardsAugust25LP.json": [
		60018,
		60018
	],
	"./en-AU/regRewards.json": [
		29354,
		29354
	],
	"./en-AU/scratchGame.json": [
		86041,
		88740
	],
	"./en-AU/security.json": [
		62257,
		62257
	],
	"./en-AU/sharkJuly25LP.json": [
		32200,
		32200
	],
	"./en-AU/slotsCircle.json": [
		53541,
		53541
	],
	"./en-AU/sportsDeposit.json": [
		3522,
		3522
	],
	"./en-AU/sunOfEgypt.json": [
		37010,
		37010
	],
	"./en-AU/support.json": [
		80173,
		80173
	],
	"./en-AU/turbolvlJuly25LP.json": [
		63712,
		63712
	],
	"./en-AU/validation.json": [
		31905,
		31905
	],
	"./en-AU/verification.json": [
		29887,
		29887
	],
	"./en-AU/vip.json": [
		73144,
		73144
	],
	"./en-AU/vipGemCards.json": [
		22892,
		22892
	],
	"./en-AU/welcomeApril2025.json": [
		77135,
		77135
	],
	"./en-AU/wheel.json": [
		9429,
		9429
	],
	"./en-AU/wheelFortuneLP.json": [
		63864,
		63864
	],
	"./en-AU/winterJanuary.json": [
		30538,
		30538
	],
	"./en-AU/withdraw.json": [
		95784,
		95784
	],
	"./en-AU/wolfElvisSunBuffalo.json": [
		44495,
		44495
	],
	"./en-AU/wolfWheelLP.json": [
		48791,
		48791
	],
	"./en-CA/CardsBenefitsJune2025LP.json": [
		33115,
		33115
	],
	"./en-CA/QuizBonusJune2025LP.json": [
		64428,
		64428
	],
	"./en-CA/aviatorup.json": [
		46697,
		46697
	],
	"./en-CA/banksBenefitsMay2025.json": [
		51181,
		51181
	],
	"./en-CA/becomeVip.json": [
		20807,
		20807
	],
	"./en-CA/bigBass.json": [
		94910,
		94910
	],
	"./en-CA/blackWheelLP.json": [
		68274,
		68274
	],
	"./en-CA/bonanzaPromo.json": [
		60862,
		60862
	],
	"./en-CA/bonusClaimLP.json": [
		31321,
		31321
	],
	"./en-CA/bonuses.json": [
		26433,
		26433
	],
	"./en-CA/buffaloWheel.json": [
		20994,
		20994
	],
	"./en-CA/carways2025LP.json": [
		22577,
		22577
	],
	"./en-CA/cashbox.json": [
		64942,
		64942
	],
	"./en-CA/cashupBonanza.json": [
		35675,
		35675
	],
	"./en-CA/centredRegFormLP.json": [
		42402,
		42402
	],
	"./en-CA/circleLP.json": [
		25067,
		25067
	],
	"./en-CA/circusNovember.json": [
		10928,
		10928
	],
	"./en-CA/common.json": [
		20108,
		20108
	],
	"./en-CA/crownApril25.json": [
		11040,
		11040
	],
	"./en-CA/crownBanner.json": [
		10650,
		10650
	],
	"./en-CA/crownMarch25.json": [
		24667,
		24667
	],
	"./en-CA/crownWheelBlack.json": [
		26371,
		26371
	],
	"./en-CA/crownWheelBlackLP.json": [
		12504,
		12504
	],
	"./en-CA/cryptoExclusiveMay25LP.json": [
		22218,
		22218
	],
	"./en-CA/cryptoOfferMay25LP.json": [
		88066,
		88066
	],
	"./en-CA/deposits.json": [
		31703,
		31703
	],
	"./en-CA/dialogs.json": [
		62928,
		62928
	],
	"./en-CA/diceRoll.json": [
		28863,
		28863
	],
	"./en-CA/dogTreasure.json": [
		9858,
		9858
	],
	"./en-CA/dogTreasureTerms.json": [
		23679,
		23679
	],
	"./en-CA/easterApril2025.json": [
		98899,
		98899
	],
	"./en-CA/easterMissions.json": [
		60843,
		60843
	],
	"./en-CA/fiestaJune25LP.json": [
		71833,
		71833
	],
	"./en-CA/fruitsupMarch25.json": [
		69217,
		69217
	],
	"./en-CA/gatesOfOlympusLP.json": [
		24507,
		24507
	],
	"./en-CA/glossary.json": [
		21178,
		21178
	],
	"./en-CA/history.json": [
		3539,
		3539
	],
	"./en-CA/jackpot.json": [
		51922,
		51922
	],
	"./en-CA/juicyCarMay2025.json": [
		58070,
		58070
	],
	"./en-CA/juicyMay.json": [
		86951,
		86951
	],
	"./en-CA/leaveDeposit.json": [
		27818,
		27818
	],
	"./en-CA/leaveRegistration.json": [
		40473,
		40473
	],
	"./en-CA/limits.json": [
		95515,
		95515
	],
	"./en-CA/lobby.json": [
		36711,
		36711
	],
	"./en-CA/lootboxes.json": [
		40868,
		40868
	],
	"./en-CA/loyalty.json": [
		40991,
		40991
	],
	"./en-CA/lpAssets.json": [
		73191,
		73191
	],
	"./en-CA/lyzer40BanksBenefitsJune2025LP.json": [
		47367,
		47367
	],
	"./en-CA/march2025.json": [
		61973,
		61973
	],
	"./en-CA/mobileApp.json": [
		75399,
		75399
	],
	"./en-CA/personal.json": [
		48327,
		48327
	],
	"./en-CA/profile.json": [
		76363,
		76363
	],
	"./en-CA/promotions.json": [
		86033,
		86033
	],
	"./en-CA/referralSystem.json": [
		15346,
		15346
	],
	"./en-CA/regDragonRewards.json": [
		21466,
		21466
	],
	"./en-CA/regDragonRewardsAugust25LP.json": [
		26666,
		26666
	],
	"./en-CA/regRewards.json": [
		12240,
		12240
	],
	"./en-CA/scratchGame.json": [
		37794,
		37794
	],
	"./en-CA/security.json": [
		83078,
		83078
	],
	"./en-CA/sharkJuly25LP.json": [
		54729,
		54729
	],
	"./en-CA/slotsCircle.json": [
		83663,
		83663
	],
	"./en-CA/sportsDeposit.json": [
		12668,
		12668
	],
	"./en-CA/sunOfEgypt.json": [
		8524,
		8524
	],
	"./en-CA/support.json": [
		66416,
		66416
	],
	"./en-CA/turbolvlJuly25LP.json": [
		89696,
		89696
	],
	"./en-CA/validation.json": [
		41927,
		41927
	],
	"./en-CA/verification.json": [
		70737,
		70737
	],
	"./en-CA/vip.json": [
		81864,
		81864
	],
	"./en-CA/vipGemCards.json": [
		59507,
		59507
	],
	"./en-CA/welcomeApril2025.json": [
		22428,
		22428
	],
	"./en-CA/wheel.json": [
		75859,
		75859
	],
	"./en-CA/wheelFortuneLP.json": [
		12518,
		12518
	],
	"./en-CA/winterJanuary.json": [
		47887,
		47887
	],
	"./en-CA/withdraw.json": [
		67867,
		67867
	],
	"./en-CA/wolfElvisSunBuffalo.json": [
		72764,
		72764
	],
	"./en-CA/wolfWheelLP.json": [
		56752,
		56752
	],
	"./en-IE/CardsBenefitsJune2025LP.json": [
		5494,
		5494
	],
	"./en-IE/QuizBonusJune2025LP.json": [
		158,
		158
	],
	"./en-IE/aviatorup.json": [
		33475,
		33475
	],
	"./en-IE/banksBenefitsMay2025.json": [
		92873,
		92873
	],
	"./en-IE/becomeVip.json": [
		46062,
		46062
	],
	"./en-IE/bigBass.json": [
		83289,
		83289
	],
	"./en-IE/blackWheelLP.json": [
		64032,
		64032
	],
	"./en-IE/bonanzaPromo.json": [
		57845,
		57845
	],
	"./en-IE/bonusClaimLP.json": [
		7751,
		7751
	],
	"./en-IE/bonuses.json": [
		50961,
		50961
	],
	"./en-IE/buffaloWheel.json": [
		98785,
		98785
	],
	"./en-IE/carways2025LP.json": [
		93002,
		44467
	],
	"./en-IE/cashbox.json": [
		83269,
		83269
	],
	"./en-IE/cashupBonanza.json": [
		19070,
		19070
	],
	"./en-IE/centredRegFormLP.json": [
		73258,
		73258
	],
	"./en-IE/circleLP.json": [
		58973,
		58973
	],
	"./en-IE/circusNovember.json": [
		64459,
		64459
	],
	"./en-IE/common.json": [
		39699,
		39699
	],
	"./en-IE/crownApril25.json": [
		21732,
		21732
	],
	"./en-IE/crownBanner.json": [
		57839,
		57839
	],
	"./en-IE/crownMarch25.json": [
		24384,
		24384
	],
	"./en-IE/crownWheelBlack.json": [
		62192,
		62192
	],
	"./en-IE/crownWheelBlackLP.json": [
		84242,
		84242
	],
	"./en-IE/cryptoExclusiveMay25LP.json": [
		79340,
		79340
	],
	"./en-IE/cryptoOfferMay25LP.json": [
		4786,
		4786
	],
	"./en-IE/deposits.json": [
		10698,
		10698
	],
	"./en-IE/dialogs.json": [
		52597,
		52597
	],
	"./en-IE/diceRoll.json": [
		52437,
		52437
	],
	"./en-IE/dogTreasure.json": [
		53433,
		53433
	],
	"./en-IE/dogTreasureTerms.json": [
		98398,
		98398
	],
	"./en-IE/easterApril2025.json": [
		33219,
		17460
	],
	"./en-IE/easterMissions.json": [
		68272,
		68272
	],
	"./en-IE/fiestaJune25LP.json": [
		89218,
		89218
	],
	"./en-IE/fruitsupMarch25.json": [
		97612,
		97612
	],
	"./en-IE/gatesOfOlympusLP.json": [
		98119,
		98119
	],
	"./en-IE/glossary.json": [
		40355,
		40355
	],
	"./en-IE/history.json": [
		62932,
		62932
	],
	"./en-IE/jackpot.json": [
		97851,
		97851
	],
	"./en-IE/juicyCarMay2025.json": [
		34353,
		34353
	],
	"./en-IE/juicyMay.json": [
		32928,
		32928
	],
	"./en-IE/leaveDeposit.json": [
		39614,
		39614
	],
	"./en-IE/leaveRegistration.json": [
		60132,
		60132
	],
	"./en-IE/limits.json": [
		99597,
		99597
	],
	"./en-IE/lobby.json": [
		6844,
		6844
	],
	"./en-IE/lootboxes.json": [
		29960,
		29960
	],
	"./en-IE/loyalty.json": [
		2756,
		2756
	],
	"./en-IE/lpAssets.json": [
		21450,
		21450
	],
	"./en-IE/lyzer40BanksBenefitsJune2025LP.json": [
		67522,
		67522
	],
	"./en-IE/march2025.json": [
		46206,
		87401
	],
	"./en-IE/mobileApp.json": [
		19786,
		19786
	],
	"./en-IE/personal.json": [
		5513,
		5513
	],
	"./en-IE/profile.json": [
		75519,
		75519
	],
	"./en-IE/promotions.json": [
		99020,
		99020
	],
	"./en-IE/referralSystem.json": [
		5521,
		5521
	],
	"./en-IE/regDragonRewards.json": [
		19733,
		19733
	],
	"./en-IE/regDragonRewardsAugust25LP.json": [
		87548,
		87548
	],
	"./en-IE/regRewards.json": [
		79172,
		79172
	],
	"./en-IE/scratchGame.json": [
		50323,
		50323
	],
	"./en-IE/security.json": [
		29347,
		29347
	],
	"./en-IE/sharkJuly25LP.json": [
		4715,
		4715
	],
	"./en-IE/slotsCircle.json": [
		60000,
		60000
	],
	"./en-IE/sportsDeposit.json": [
		62142,
		62142
	],
	"./en-IE/sunOfEgypt.json": [
		40668,
		40668
	],
	"./en-IE/support.json": [
		17572,
		17572
	],
	"./en-IE/turbolvlJuly25LP.json": [
		83513,
		83513
	],
	"./en-IE/validation.json": [
		94342,
		94342
	],
	"./en-IE/verification.json": [
		29764,
		29764
	],
	"./en-IE/vip.json": [
		18711,
		18711
	],
	"./en-IE/vipGemCards.json": [
		19251,
		19251
	],
	"./en-IE/welcomeApril2025.json": [
		53629,
		53629
	],
	"./en-IE/wheel.json": [
		79459,
		79459
	],
	"./en-IE/wheelFortuneLP.json": [
		85170,
		85170
	],
	"./en-IE/winterJanuary.json": [
		33768,
		33768
	],
	"./en-IE/withdraw.json": [
		30869,
		30869
	],
	"./en-IE/wolfElvisSunBuffalo.json": [
		46338,
		46338
	],
	"./en-IE/wolfWheelLP.json": [
		19864,
		19864
	],
	"./en-NZ/CardsBenefitsJune2025LP.json": [
		25735,
		25735
	],
	"./en-NZ/QuizBonusJune2025LP.json": [
		82828,
		82828
	],
	"./en-NZ/aviatorup.json": [
		63895,
		63895
	],
	"./en-NZ/banksBenefitsMay2025.json": [
		73526,
		73526
	],
	"./en-NZ/becomeVip.json": [
		88240,
		88240
	],
	"./en-NZ/bigBass.json": [
		72614,
		72614
	],
	"./en-NZ/blackWheelLP.json": [
		5835,
		5835
	],
	"./en-NZ/bonanzaPromo.json": [
		77070,
		77070
	],
	"./en-NZ/bonusClaimLP.json": [
		94131,
		94131
	],
	"./en-NZ/bonuses.json": [
		25014,
		25014
	],
	"./en-NZ/buffaloWheel.json": [
		28822,
		28822
	],
	"./en-NZ/carways2025LP.json": [
		77605,
		77605
	],
	"./en-NZ/cashbox.json": [
		31895,
		31895
	],
	"./en-NZ/cashupBonanza.json": [
		60783,
		60783
	],
	"./en-NZ/centredRegFormLP.json": [
		64320,
		12973
	],
	"./en-NZ/circleLP.json": [
		62961,
		62961
	],
	"./en-NZ/circusNovember.json": [
		90082,
		90082
	],
	"./en-NZ/common.json": [
		54710,
		43687
	],
	"./en-NZ/crownApril25.json": [
		49796,
		49796
	],
	"./en-NZ/crownBanner.json": [
		88286,
		88286
	],
	"./en-NZ/crownMarch25.json": [
		5838,
		5838
	],
	"./en-NZ/crownWheelBlack.json": [
		65779,
		85424
	],
	"./en-NZ/crownWheelBlackLP.json": [
		11027,
		11027
	],
	"./en-NZ/cryptoExclusiveMay25LP.json": [
		24291,
		24291
	],
	"./en-NZ/cryptoOfferMay25LP.json": [
		23788,
		23788
	],
	"./en-NZ/deposits.json": [
		13465,
		13465
	],
	"./en-NZ/dialogs.json": [
		3069,
		3069
	],
	"./en-NZ/diceRoll.json": [
		96599,
		96599
	],
	"./en-NZ/dogTreasure.json": [
		236,
		236
	],
	"./en-NZ/dogTreasureTerms.json": [
		54335,
		54335
	],
	"./en-NZ/easterApril2025.json": [
		86735,
		86735
	],
	"./en-NZ/easterMissions.json": [
		90892,
		90892
	],
	"./en-NZ/fiestaJune25LP.json": [
		8390,
		80145
	],
	"./en-NZ/fruitsupMarch25.json": [
		56098,
		56098
	],
	"./en-NZ/gatesOfOlympusLP.json": [
		53018,
		53018
	],
	"./en-NZ/glossary.json": [
		35598,
		35598
	],
	"./en-NZ/history.json": [
		54647,
		54647
	],
	"./en-NZ/jackpot.json": [
		32856,
		32856
	],
	"./en-NZ/juicyCarMay2025.json": [
		63619,
		63619
	],
	"./en-NZ/juicyMay.json": [
		49546,
		49546
	],
	"./en-NZ/leaveDeposit.json": [
		63416,
		63416
	],
	"./en-NZ/leaveRegistration.json": [
		71845,
		71845
	],
	"./en-NZ/limits.json": [
		61392,
		61392
	],
	"./en-NZ/lobby.json": [
		72948,
		72948
	],
	"./en-NZ/lootboxes.json": [
		57554,
		57554
	],
	"./en-NZ/loyalty.json": [
		82665,
		82665
	],
	"./en-NZ/lpAssets.json": [
		83086,
		83086
	],
	"./en-NZ/lyzer40BanksBenefitsJune2025LP.json": [
		56796,
		56796
	],
	"./en-NZ/march2025.json": [
		74728,
		74728
	],
	"./en-NZ/mobileApp.json": [
		78542,
		78542
	],
	"./en-NZ/personal.json": [
		37447,
		37447
	],
	"./en-NZ/profile.json": [
		28994,
		28994
	],
	"./en-NZ/promotions.json": [
		41983,
		41983
	],
	"./en-NZ/referralSystem.json": [
		92668,
		92668
	],
	"./en-NZ/regDragonRewards.json": [
		55922,
		55922
	],
	"./en-NZ/regDragonRewardsAugust25LP.json": [
		51755,
		51755
	],
	"./en-NZ/regRewards.json": [
		16836,
		16836
	],
	"./en-NZ/scratchGame.json": [
		27630,
		27630
	],
	"./en-NZ/security.json": [
		43598,
		43598
	],
	"./en-NZ/sharkJuly25LP.json": [
		79351,
		79351
	],
	"./en-NZ/slotsCircle.json": [
		58291,
		58291
	],
	"./en-NZ/sportsDeposit.json": [
		85536,
		85536
	],
	"./en-NZ/sunOfEgypt.json": [
		9471,
		9471
	],
	"./en-NZ/support.json": [
		43134,
		43134
	],
	"./en-NZ/turbolvlJuly25LP.json": [
		63206,
		63206
	],
	"./en-NZ/validation.json": [
		1940,
		1940
	],
	"./en-NZ/verification.json": [
		25168,
		25168
	],
	"./en-NZ/vip.json": [
		76306,
		76306
	],
	"./en-NZ/vipGemCards.json": [
		54735,
		54735
	],
	"./en-NZ/welcomeApril2025.json": [
		95347,
		95347
	],
	"./en-NZ/wheel.json": [
		96806,
		96806
	],
	"./en-NZ/wheelFortuneLP.json": [
		89138,
		89138
	],
	"./en-NZ/winterJanuary.json": [
		17516,
		17516
	],
	"./en-NZ/withdraw.json": [
		63186,
		63186
	],
	"./en-NZ/wolfElvisSunBuffalo.json": [
		94993,
		94993
	],
	"./en-NZ/wolfWheelLP.json": [
		82221,
		82221
	],
	"./en/CardsBenefitsJune2025LP.json": [
		96434,
		96434
	],
	"./en/QuizBonusJune2025LP.json": [
		93562,
		93562
	],
	"./en/aviatorup.json": [
		36098,
		36098
	],
	"./en/banksBenefitsMay2025.json": [
		99131,
		99131
	],
	"./en/becomeVip.json": [
		37129,
		37160
	],
	"./en/bigBass.json": [
		19316,
		19316
	],
	"./en/blackWheelLP.json": [
		4012,
		4012
	],
	"./en/bonanzaPromo.json": [
		8940,
		8940
	],
	"./en/bonusClaimLP.json": [
		87839,
		87839
	],
	"./en/bonuses.json": [
		99887,
		99887
	],
	"./en/buffaloWheel.json": [
		95685,
		95685
	],
	"./en/carways2025LP.json": [
		4735,
		4735
	],
	"./en/cashbox.json": [
		83188,
		83188
	],
	"./en/cashupBonanza.json": [
		5657,
		5657
	],
	"./en/centredRegFormLP.json": [
		3396,
		3396
	],
	"./en/circleLP.json": [
		53691,
		53691
	],
	"./en/circusNovember.json": [
		38371,
		38371
	],
	"./en/common.json": [
		40464,
		40464
	],
	"./en/crownApril25.json": [
		61408,
		61408
	],
	"./en/crownBanner.json": [
		54375,
		54375
	],
	"./en/crownMarch25.json": [
		642,
		642
	],
	"./en/crownWheelBlack.json": [
		90968,
		90968
	],
	"./en/crownWheelBlackLP.json": [
		74351,
		74351
	],
	"./en/cryptoExclusiveMay25LP.json": [
		30201,
		30201
	],
	"./en/cryptoOfferMay25LP.json": [
		18833,
		18833
	],
	"./en/deposits.json": [
		15408,
		15408
	],
	"./en/dialogs.json": [
		85573,
		85573
	],
	"./en/diceRoll.json": [
		40696,
		40696
	],
	"./en/dogTreasure.json": [
		42248,
		42248
	],
	"./en/dogTreasureTerms.json": [
		40614,
		40614
	],
	"./en/easterApril2025.json": [
		78630,
		78630
	],
	"./en/easterMissions.json": [
		34460,
		34460
	],
	"./en/fiestaJune25LP.json": [
		4038,
		4038
	],
	"./en/fruitsupMarch25.json": [
		2028,
		2028
	],
	"./en/gatesOfOlympusLP.json": [
		81993,
		81993
	],
	"./en/glossary.json": [
		98825,
		98825
	],
	"./en/history.json": [
		4254,
		4254
	],
	"./en/jackpot.json": [
		3122,
		3122
	],
	"./en/juicyCarMay2025.json": [
		73248,
		73248
	],
	"./en/juicyMay.json": [
		14131,
		14131
	],
	"./en/leaveDeposit.json": [
		23658,
		23658
	],
	"./en/leaveRegistration.json": [
		56881,
		56881
	],
	"./en/limits.json": [
		27824,
		27824
	],
	"./en/lobby.json": [
		64689,
		64689
	],
	"./en/lootboxes.json": [
		9949,
		9949
	],
	"./en/loyalty.json": [
		5136,
		5136
	],
	"./en/lpAssets.json": [
		23965,
		23965
	],
	"./en/lyzer40BanksBenefitsJune2025LP.json": [
		39367,
		39367
	],
	"./en/march2025.json": [
		36187,
		36187
	],
	"./en/mobileApp.json": [
		36356,
		36356
	],
	"./en/personal.json": [
		75714,
		75714
	],
	"./en/profile.json": [
		81140,
		81140
	],
	"./en/promotions.json": [
		11812,
		11812
	],
	"./en/referralSystem.json": [
		10075,
		10075
	],
	"./en/regDragonRewards.json": [
		12077,
		12077
	],
	"./en/regDragonRewardsAugust25LP.json": [
		22277,
		22277
	],
	"./en/regRewards.json": [
		53277,
		53277
	],
	"./en/scratchGame.json": [
		96608,
		96608
	],
	"./en/security.json": [
		35990,
		35990
	],
	"./en/sharkJuly25LP.json": [
		60656,
		60656
	],
	"./en/slotsCircle.json": [
		76522,
		76522
	],
	"./en/sportsDeposit.json": [
		95002,
		95002
	],
	"./en/sunOfEgypt.json": [
		55506,
		55506
	],
	"./en/support.json": [
		69251,
		69251
	],
	"./en/turbolvlJuly25LP.json": [
		58584,
		58584
	],
	"./en/validation.json": [
		1312,
		1312
	],
	"./en/verification.json": [
		69787,
		69787
	],
	"./en/vip.json": [
		93729,
		93729
	],
	"./en/vipGemCards.json": [
		50740,
		50740
	],
	"./en/welcomeApril2025.json": [
		69435,
		35988
	],
	"./en/wheel.json": [
		59029,
		59029
	],
	"./en/wheelFortuneLP.json": [
		58281,
		58281
	],
	"./en/winterJanuary.json": [
		96301,
		96301
	],
	"./en/withdraw.json": [
		1866,
		1866
	],
	"./en/wolfElvisSunBuffalo.json": [
		95871,
		95871
	],
	"./en/wolfWheelLP.json": [
		74958,
		74958
	],
	"./et-EE/CardsBenefitsJune2025LP.json": [
		34275,
		34275
	],
	"./et-EE/QuizBonusJune2025LP.json": [
		60116,
		60116
	],
	"./et-EE/aviatorup.json": [
		12703,
		12703
	],
	"./et-EE/banksBenefitsMay2025.json": [
		33763,
		33763
	],
	"./et-EE/becomeVip.json": [
		54088,
		54088
	],
	"./et-EE/bigBass.json": [
		29225,
		29225
	],
	"./et-EE/blackWheelLP.json": [
		24221,
		24221
	],
	"./et-EE/bonanzaPromo.json": [
		55708,
		55708
	],
	"./et-EE/bonusClaimLP.json": [
		14290,
		14290
	],
	"./et-EE/bonuses.json": [
		80915,
		80915
	],
	"./et-EE/buffaloWheel.json": [
		13352,
		13352
	],
	"./et-EE/carways2025LP.json": [
		14997,
		14997
	],
	"./et-EE/cashbox.json": [
		90410,
		90410
	],
	"./et-EE/cashupBonanza.json": [
		69715,
		69715
	],
	"./et-EE/centredRegFormLP.json": [
		87949,
		87949
	],
	"./et-EE/circleLP.json": [
		16288,
		16288
	],
	"./et-EE/circusNovember.json": [
		63137,
		63137
	],
	"./et-EE/common.json": [
		65592,
		65592
	],
	"./et-EE/crownApril25.json": [
		49186,
		49186
	],
	"./et-EE/crownBanner.json": [
		58218,
		13053
	],
	"./et-EE/crownMarch25.json": [
		14517,
		14517
	],
	"./et-EE/crownWheelBlack.json": [
		96927,
		96927
	],
	"./et-EE/crownWheelBlackLP.json": [
		70808,
		70808
	],
	"./et-EE/cryptoExclusiveMay25LP.json": [
		43803,
		43803
	],
	"./et-EE/cryptoOfferMay25LP.json": [
		69258,
		69258
	],
	"./et-EE/deposits.json": [
		55743,
		55743
	],
	"./et-EE/dialogs.json": [
		74959,
		74959
	],
	"./et-EE/diceRoll.json": [
		52135,
		52135
	],
	"./et-EE/dogTreasure.json": [
		87446,
		87446
	],
	"./et-EE/dogTreasureTerms.json": [
		93942,
		93942
	],
	"./et-EE/easterApril2025.json": [
		59730,
		95188
	],
	"./et-EE/easterMissions.json": [
		34692,
		34692
	],
	"./et-EE/fiestaJune25LP.json": [
		61566,
		61566
	],
	"./et-EE/fruitsupMarch25.json": [
		46035,
		46035
	],
	"./et-EE/gatesOfOlympusLP.json": [
		20142,
		20142
	],
	"./et-EE/glossary.json": [
		31296,
		31296
	],
	"./et-EE/history.json": [
		23765,
		23765
	],
	"./et-EE/jackpot.json": [
		64016,
		64016
	],
	"./et-EE/juicyCarMay2025.json": [
		54298,
		54298
	],
	"./et-EE/juicyMay.json": [
		83747,
		83747
	],
	"./et-EE/leaveDeposit.json": [
		61941,
		61941
	],
	"./et-EE/leaveRegistration.json": [
		20019,
		20019
	],
	"./et-EE/limits.json": [
		21108,
		21108
	],
	"./et-EE/lobby.json": [
		83175,
		83175
	],
	"./et-EE/lootboxes.json": [
		85945,
		85945
	],
	"./et-EE/loyalty.json": [
		82918,
		82918
	],
	"./et-EE/lpAssets.json": [
		53517,
		53517
	],
	"./et-EE/lyzer40BanksBenefitsJune2025LP.json": [
		20644,
		20644
	],
	"./et-EE/march2025.json": [
		58942,
		58942
	],
	"./et-EE/mobileApp.json": [
		3666,
		3666
	],
	"./et-EE/personal.json": [
		58023,
		58023
	],
	"./et-EE/profile.json": [
		28448,
		28448
	],
	"./et-EE/promotions.json": [
		73899,
		73899
	],
	"./et-EE/referralSystem.json": [
		1340,
		1340
	],
	"./et-EE/regDragonRewards.json": [
		66624,
		20086
	],
	"./et-EE/regDragonRewardsAugust25LP.json": [
		18400,
		18400
	],
	"./et-EE/regRewards.json": [
		15067,
		15067
	],
	"./et-EE/scratchGame.json": [
		89004,
		89004
	],
	"./et-EE/security.json": [
		67119,
		67119
	],
	"./et-EE/sharkJuly25LP.json": [
		93218,
		93218
	],
	"./et-EE/slotsCircle.json": [
		45442,
		45442
	],
	"./et-EE/sportsDeposit.json": [
		48053,
		48053
	],
	"./et-EE/sunOfEgypt.json": [
		74080,
		74080
	],
	"./et-EE/support.json": [
		46030,
		46030
	],
	"./et-EE/turbolvlJuly25LP.json": [
		75858,
		75858
	],
	"./et-EE/validation.json": [
		9130,
		9130
	],
	"./et-EE/verification.json": [
		74708,
		74708
	],
	"./et-EE/vip.json": [
		85197,
		85197
	],
	"./et-EE/vipGemCards.json": [
		65002,
		65002
	],
	"./et-EE/welcomeApril2025.json": [
		99301,
		99301
	],
	"./et-EE/wheel.json": [
		7576,
		7576
	],
	"./et-EE/wheelFortuneLP.json": [
		44975,
		44975
	],
	"./et-EE/winterJanuary.json": [
		10142,
		10142
	],
	"./et-EE/withdraw.json": [
		684,
		684
	],
	"./et-EE/wolfElvisSunBuffalo.json": [
		52958,
		52958
	],
	"./et-EE/wolfWheelLP.json": [
		52821,
		52821
	],
	"./fi/CardsBenefitsJune2025LP.json": [
		4247,
		4247
	],
	"./fi/QuizBonusJune2025LP.json": [
		84842,
		84842
	],
	"./fi/aviatorup.json": [
		89099,
		89099
	],
	"./fi/banksBenefitsMay2025.json": [
		40254,
		40254
	],
	"./fi/becomeVip.json": [
		60029,
		60029
	],
	"./fi/bigBass.json": [
		82180,
		82180
	],
	"./fi/blackWheelLP.json": [
		36500,
		36500
	],
	"./fi/bonanzaPromo.json": [
		28044,
		28044
	],
	"./fi/bonusClaimLP.json": [
		95956,
		95956
	],
	"./fi/bonuses.json": [
		37876,
		37876
	],
	"./fi/buffaloWheel.json": [
		48831,
		48831
	],
	"./fi/carways2025LP.json": [
		53184,
		53184
	],
	"./fi/cashbox.json": [
		75338,
		75338
	],
	"./fi/cashupBonanza.json": [
		8994,
		8994
	],
	"./fi/centredRegFormLP.json": [
		13177,
		13177
	],
	"./fi/circleLP.json": [
		53646,
		53646
	],
	"./fi/circusNovember.json": [
		90283,
		90283
	],
	"./fi/common.json": [
		8418,
		8418
	],
	"./fi/crownApril25.json": [
		5647,
		5647
	],
	"./fi/crownBanner.json": [
		6161,
		6161
	],
	"./fi/crownMarch25.json": [
		93819,
		93819
	],
	"./fi/crownWheelBlack.json": [
		34070,
		34070
	],
	"./fi/crownWheelBlackLP.json": [
		47828,
		47828
	],
	"./fi/cryptoExclusiveMay25LP.json": [
		86135,
		86135
	],
	"./fi/cryptoOfferMay25LP.json": [
		21791,
		21791
	],
	"./fi/deposits.json": [
		74871,
		74871
	],
	"./fi/dialogs.json": [
		59580,
		59580
	],
	"./fi/diceRoll.json": [
		69841,
		69841
	],
	"./fi/dogTreasure.json": [
		72202,
		72202
	],
	"./fi/dogTreasureTerms.json": [
		93943,
		93943
	],
	"./fi/easterApril2025.json": [
		91244,
		91244
	],
	"./fi/easterMissions.json": [
		60037,
		60037
	],
	"./fi/fiestaJune25LP.json": [
		15191,
		15191
	],
	"./fi/fruitsupMarch25.json": [
		96113,
		96113
	],
	"./fi/gatesOfOlympusLP.json": [
		83689,
		83689
	],
	"./fi/glossary.json": [
		217,
		217
	],
	"./fi/history.json": [
		35405,
		35405
	],
	"./fi/jackpot.json": [
		74853,
		74853
	],
	"./fi/juicyCarMay2025.json": [
		59228,
		59228
	],
	"./fi/juicyMay.json": [
		90341,
		90341
	],
	"./fi/leaveDeposit.json": [
		14346,
		14346
	],
	"./fi/leaveRegistration.json": [
		54391,
		54391
	],
	"./fi/limits.json": [
		50097,
		50097
	],
	"./fi/lobby.json": [
		60501,
		60501
	],
	"./fi/lootboxes.json": [
		96780,
		96780
	],
	"./fi/loyalty.json": [
		89096,
		89096
	],
	"./fi/lpAssets.json": [
		93029,
		93029
	],
	"./fi/lyzer40BanksBenefitsJune2025LP.json": [
		46676,
		46676
	],
	"./fi/march2025.json": [
		33104,
		33104
	],
	"./fi/mobileApp.json": [
		46469,
		46469
	],
	"./fi/personal.json": [
		95116,
		95116
	],
	"./fi/profile.json": [
		5831,
		5831
	],
	"./fi/promotions.json": [
		76220,
		76220
	],
	"./fi/referralSystem.json": [
		98412,
		98412
	],
	"./fi/regDragonRewards.json": [
		94394,
		94394
	],
	"./fi/regDragonRewardsAugust25LP.json": [
		36650,
		36650
	],
	"./fi/regRewards.json": [
		24022,
		24022
	],
	"./fi/scratchGame.json": [
		87060,
		87060
	],
	"./fi/security.json": [
		50500,
		50500
	],
	"./fi/sharkJuly25LP.json": [
		51749,
		51749
	],
	"./fi/slotsCircle.json": [
		8000,
		8000
	],
	"./fi/sportsDeposit.json": [
		29957,
		29957
	],
	"./fi/sunOfEgypt.json": [
		67311,
		67311
	],
	"./fi/support.json": [
		56075,
		56075
	],
	"./fi/turbolvlJuly25LP.json": [
		65915,
		65915
	],
	"./fi/validation.json": [
		96227,
		46310
	],
	"./fi/verification.json": [
		74797,
		74797
	],
	"./fi/vip.json": [
		90527,
		90527
	],
	"./fi/vipGemCards.json": [
		12418,
		12418
	],
	"./fi/welcomeApril2025.json": [
		94237,
		94237
	],
	"./fi/wheel.json": [
		7503,
		7503
	],
	"./fi/wheelFortuneLP.json": [
		96299,
		96299
	],
	"./fi/winterJanuary.json": [
		22649,
		22649
	],
	"./fi/withdraw.json": [
		85914,
		85914
	],
	"./fi/wolfElvisSunBuffalo.json": [
		36043,
		36043
	],
	"./fi/wolfWheelLP.json": [
		10867,
		10867
	],
	"./fr-CA/CardsBenefitsJune2025LP.json": [
		21869,
		21869
	],
	"./fr-CA/QuizBonusJune2025LP.json": [
		89017,
		89017
	],
	"./fr-CA/aviatorup.json": [
		74777,
		74777
	],
	"./fr-CA/banksBenefitsMay2025.json": [
		2834,
		2834
	],
	"./fr-CA/becomeVip.json": [
		96399,
		96399
	],
	"./fr-CA/bigBass.json": [
		89674,
		89674
	],
	"./fr-CA/blackWheelLP.json": [
		3372,
		3372
	],
	"./fr-CA/bonanzaPromo.json": [
		23910,
		36609
	],
	"./fr-CA/bonusClaimLP.json": [
		94692,
		94692
	],
	"./fr-CA/bonuses.json": [
		76000,
		76000
	],
	"./fr-CA/buffaloWheel.json": [
		83503,
		83503
	],
	"./fr-CA/carways2025LP.json": [
		31904,
		31904
	],
	"./fr-CA/cashbox.json": [
		21760,
		21760
	],
	"./fr-CA/cashupBonanza.json": [
		58200,
		58200
	],
	"./fr-CA/centredRegFormLP.json": [
		72350,
		72350
	],
	"./fr-CA/circleLP.json": [
		31610,
		31610
	],
	"./fr-CA/circusNovember.json": [
		52207,
		52207
	],
	"./fr-CA/common.json": [
		902,
		902
	],
	"./fr-CA/crownApril25.json": [
		91375,
		91375
	],
	"./fr-CA/crownBanner.json": [
		19059,
		19059
	],
	"./fr-CA/crownMarch25.json": [
		73147,
		73147
	],
	"./fr-CA/crownWheelBlack.json": [
		68207,
		68207
	],
	"./fr-CA/crownWheelBlackLP.json": [
		78417,
		78417
	],
	"./fr-CA/cryptoExclusiveMay25LP.json": [
		36446,
		36446
	],
	"./fr-CA/cryptoOfferMay25LP.json": [
		3710,
		3710
	],
	"./fr-CA/deposits.json": [
		36820,
		36820
	],
	"./fr-CA/dialogs.json": [
		54083,
		54083
	],
	"./fr-CA/diceRoll.json": [
		91613,
		91613
	],
	"./fr-CA/dogTreasure.json": [
		91172,
		91172
	],
	"./fr-CA/dogTreasureTerms.json": [
		25110,
		25110
	],
	"./fr-CA/easterApril2025.json": [
		89023,
		89023
	],
	"./fr-CA/easterMissions.json": [
		72858,
		72858
	],
	"./fr-CA/fiestaJune25LP.json": [
		13500,
		13500
	],
	"./fr-CA/fruitsupMarch25.json": [
		49752,
		49752
	],
	"./fr-CA/gatesOfOlympusLP.json": [
		87974,
		87974
	],
	"./fr-CA/glossary.json": [
		55423,
		55423
	],
	"./fr-CA/history.json": [
		5935,
		5935
	],
	"./fr-CA/jackpot.json": [
		25017,
		25017
	],
	"./fr-CA/juicyCarMay2025.json": [
		34687,
		34687
	],
	"./fr-CA/juicyMay.json": [
		54468,
		54468
	],
	"./fr-CA/leaveDeposit.json": [
		41764,
		41764
	],
	"./fr-CA/leaveRegistration.json": [
		94205,
		94205
	],
	"./fr-CA/limits.json": [
		72330,
		72330
	],
	"./fr-CA/lobby.json": [
		83942,
		83942
	],
	"./fr-CA/lootboxes.json": [
		72124,
		72124
	],
	"./fr-CA/loyalty.json": [
		30137,
		30137
	],
	"./fr-CA/lpAssets.json": [
		37068,
		37068
	],
	"./fr-CA/lyzer40BanksBenefitsJune2025LP.json": [
		69278,
		85570
	],
	"./fr-CA/march2025.json": [
		2649,
		2649
	],
	"./fr-CA/mobileApp.json": [
		99669,
		99669
	],
	"./fr-CA/personal.json": [
		41277,
		41277
	],
	"./fr-CA/profile.json": [
		64253,
		64253
	],
	"./fr-CA/promotions.json": [
		10666,
		10666
	],
	"./fr-CA/referralSystem.json": [
		6509,
		6509
	],
	"./fr-CA/regDragonRewards.json": [
		34485,
		34485
	],
	"./fr-CA/regDragonRewardsAugust25LP.json": [
		30499,
		30499
	],
	"./fr-CA/regRewards.json": [
		23458,
		23458
	],
	"./fr-CA/scratchGame.json": [
		53761,
		53761
	],
	"./fr-CA/security.json": [
		14196,
		14196
	],
	"./fr-CA/sharkJuly25LP.json": [
		25977,
		25977
	],
	"./fr-CA/slotsCircle.json": [
		89657,
		89657
	],
	"./fr-CA/sportsDeposit.json": [
		23650,
		23650
	],
	"./fr-CA/sunOfEgypt.json": [
		91743,
		52239
	],
	"./fr-CA/support.json": [
		17883,
		17883
	],
	"./fr-CA/turbolvlJuly25LP.json": [
		33729,
		33729
	],
	"./fr-CA/validation.json": [
		26949,
		59730
	],
	"./fr-CA/verification.json": [
		36350,
		36350
	],
	"./fr-CA/vip.json": [
		28181,
		28181
	],
	"./fr-CA/vipGemCards.json": [
		75649,
		75649
	],
	"./fr-CA/welcomeApril2025.json": [
		61385,
		61385
	],
	"./fr-CA/wheel.json": [
		39389,
		39389
	],
	"./fr-CA/wheelFortuneLP.json": [
		1491,
		1491
	],
	"./fr-CA/winterJanuary.json": [
		58932,
		58932
	],
	"./fr-CA/withdraw.json": [
		73022,
		73022
	],
	"./fr-CA/wolfElvisSunBuffalo.json": [
		74518,
		74518
	],
	"./fr-CA/wolfWheelLP.json": [
		66359,
		66359
	],
	"./fr-CH/CardsBenefitsJune2025LP.json": [
		12527,
		12527
	],
	"./fr-CH/QuizBonusJune2025LP.json": [
		81994,
		81994
	],
	"./fr-CH/aviatorup.json": [
		18185,
		18185
	],
	"./fr-CH/banksBenefitsMay2025.json": [
		66791,
		66791
	],
	"./fr-CH/becomeVip.json": [
		23210,
		23210
	],
	"./fr-CH/bigBass.json": [
		44523,
		44523
	],
	"./fr-CH/blackWheelLP.json": [
		13573,
		13573
	],
	"./fr-CH/bonanzaPromo.json": [
		39764,
		39764
	],
	"./fr-CH/bonusClaimLP.json": [
		69572,
		69572
	],
	"./fr-CH/bonuses.json": [
		34119,
		34119
	],
	"./fr-CH/buffaloWheel.json": [
		86376,
		86376
	],
	"./fr-CH/carways2025LP.json": [
		67523,
		67523
	],
	"./fr-CH/cashbox.json": [
		58295,
		58295
	],
	"./fr-CH/cashupBonanza.json": [
		26155,
		10003
	],
	"./fr-CH/centredRegFormLP.json": [
		73975,
		73975
	],
	"./fr-CH/circleLP.json": [
		5638,
		5638
	],
	"./fr-CH/circusNovember.json": [
		49042,
		49042
	],
	"./fr-CH/common.json": [
		9292,
		9292
	],
	"./fr-CH/crownApril25.json": [
		25217,
		25217
	],
	"./fr-CH/crownBanner.json": [
		59204,
		59204
	],
	"./fr-CH/crownMarch25.json": [
		52391,
		52391
	],
	"./fr-CH/crownWheelBlack.json": [
		82343,
		82343
	],
	"./fr-CH/crownWheelBlackLP.json": [
		95964,
		95964
	],
	"./fr-CH/cryptoExclusiveMay25LP.json": [
		71881,
		71881
	],
	"./fr-CH/cryptoOfferMay25LP.json": [
		38471,
		38471
	],
	"./fr-CH/deposits.json": [
		83070,
		83070
	],
	"./fr-CH/dialogs.json": [
		23273,
		23273
	],
	"./fr-CH/diceRoll.json": [
		40372,
		40372
	],
	"./fr-CH/dogTreasure.json": [
		93800,
		93800
	],
	"./fr-CH/dogTreasureTerms.json": [
		26398,
		26398
	],
	"./fr-CH/easterApril2025.json": [
		11790,
		11790
	],
	"./fr-CH/easterMissions.json": [
		23565,
		23565
	],
	"./fr-CH/fiestaJune25LP.json": [
		5107,
		5107
	],
	"./fr-CH/fruitsupMarch25.json": [
		25332,
		25332
	],
	"./fr-CH/gatesOfOlympusLP.json": [
		79717,
		79717
	],
	"./fr-CH/glossary.json": [
		85575,
		85575
	],
	"./fr-CH/history.json": [
		29394,
		29394
	],
	"./fr-CH/jackpot.json": [
		19639,
		19639
	],
	"./fr-CH/juicyCarMay2025.json": [
		38232,
		38232
	],
	"./fr-CH/juicyMay.json": [
		78899,
		78899
	],
	"./fr-CH/leaveDeposit.json": [
		15668,
		15668
	],
	"./fr-CH/leaveRegistration.json": [
		90167,
		90167
	],
	"./fr-CH/limits.json": [
		42611,
		42611
	],
	"./fr-CH/lobby.json": [
		5782,
		5782
	],
	"./fr-CH/lootboxes.json": [
		66730,
		66730
	],
	"./fr-CH/loyalty.json": [
		40025,
		40025
	],
	"./fr-CH/lpAssets.json": [
		51313,
		51313
	],
	"./fr-CH/lyzer40BanksBenefitsJune2025LP.json": [
		96607,
		96607
	],
	"./fr-CH/march2025.json": [
		50651,
		50651
	],
	"./fr-CH/mobileApp.json": [
		35177,
		35177
	],
	"./fr-CH/personal.json": [
		74918,
		74918
	],
	"./fr-CH/profile.json": [
		17709,
		17709
	],
	"./fr-CH/promotions.json": [
		86743,
		86743
	],
	"./fr-CH/referralSystem.json": [
		9144,
		9144
	],
	"./fr-CH/regDragonRewards.json": [
		54618,
		54618
	],
	"./fr-CH/regDragonRewardsAugust25LP.json": [
		22267,
		22267
	],
	"./fr-CH/regRewards.json": [
		96107,
		96107
	],
	"./fr-CH/scratchGame.json": [
		69373,
		69373
	],
	"./fr-CH/security.json": [
		80261,
		26229
	],
	"./fr-CH/sharkJuly25LP.json": [
		39526,
		39526
	],
	"./fr-CH/slotsCircle.json": [
		46759,
		46759
	],
	"./fr-CH/sportsDeposit.json": [
		23909,
		8005
	],
	"./fr-CH/sunOfEgypt.json": [
		96994,
		96994
	],
	"./fr-CH/support.json": [
		62919,
		62919
	],
	"./fr-CH/turbolvlJuly25LP.json": [
		67775,
		67775
	],
	"./fr-CH/validation.json": [
		28450,
		28450
	],
	"./fr-CH/verification.json": [
		37673,
		37673
	],
	"./fr-CH/vip.json": [
		67599,
		67599
	],
	"./fr-CH/vipGemCards.json": [
		79538,
		79538
	],
	"./fr-CH/welcomeApril2025.json": [
		84622,
		84622
	],
	"./fr-CH/wheel.json": [
		20474,
		20474
	],
	"./fr-CH/wheelFortuneLP.json": [
		66310,
		66310
	],
	"./fr-CH/winterJanuary.json": [
		99497,
		99497
	],
	"./fr-CH/withdraw.json": [
		21770,
		21770
	],
	"./fr-CH/wolfElvisSunBuffalo.json": [
		71332,
		71332
	],
	"./fr-CH/wolfWheelLP.json": [
		37790,
		37790
	],
	"./no/CardsBenefitsJune2025LP.json": [
		66469,
		13811
	],
	"./no/QuizBonusJune2025LP.json": [
		86110,
		86110
	],
	"./no/aviatorup.json": [
		67561,
		67561
	],
	"./no/banksBenefitsMay2025.json": [
		59415,
		59415
	],
	"./no/becomeVip.json": [
		32689,
		32689
	],
	"./no/bigBass.json": [
		94749,
		94749
	],
	"./no/blackWheelLP.json": [
		61483,
		61483
	],
	"./no/bonanzaPromo.json": [
		70607,
		70607
	],
	"./no/bonusClaimLP.json": [
		28271,
		28271
	],
	"./no/bonuses.json": [
		93444,
		93444
	],
	"./no/buffaloWheel.json": [
		49039,
		49039
	],
	"./no/carways2025LP.json": [
		15398,
		15398
	],
	"./no/cashbox.json": [
		16005,
		16005
	],
	"./no/cashupBonanza.json": [
		92300,
		92300
	],
	"./no/centredRegFormLP.json": [
		42116,
		42116
	],
	"./no/circleLP.json": [
		75409,
		75409
	],
	"./no/circusNovember.json": [
		90258,
		90258
	],
	"./no/common.json": [
		70399,
		70399
	],
	"./no/crownApril25.json": [
		22210,
		22210
	],
	"./no/crownBanner.json": [
		61863,
		61863
	],
	"./no/crownMarch25.json": [
		64340,
		64340
	],
	"./no/crownWheelBlack.json": [
		97053,
		97053
	],
	"./no/crownWheelBlackLP.json": [
		4158,
		4158
	],
	"./no/cryptoExclusiveMay25LP.json": [
		60869,
		60869
	],
	"./no/cryptoOfferMay25LP.json": [
		24993,
		24993
	],
	"./no/deposits.json": [
		63194,
		63194
	],
	"./no/dialogs.json": [
		78155,
		78155
	],
	"./no/diceRoll.json": [
		87650,
		87650
	],
	"./no/dogTreasure.json": [
		98750,
		98750
	],
	"./no/dogTreasureTerms.json": [
		10277,
		10277
	],
	"./no/easterApril2025.json": [
		85212,
		70125
	],
	"./no/easterMissions.json": [
		56872,
		56872
	],
	"./no/fiestaJune25LP.json": [
		86133,
		86133
	],
	"./no/fruitsupMarch25.json": [
		96423,
		96423
	],
	"./no/gatesOfOlympusLP.json": [
		66898,
		66898
	],
	"./no/glossary.json": [
		13214,
		13214
	],
	"./no/history.json": [
		10321,
		10321
	],
	"./no/jackpot.json": [
		81636,
		81636
	],
	"./no/juicyCarMay2025.json": [
		54164,
		54164
	],
	"./no/juicyMay.json": [
		25908,
		25908
	],
	"./no/leaveDeposit.json": [
		24308,
		24308
	],
	"./no/leaveRegistration.json": [
		37253,
		37253
	],
	"./no/limits.json": [
		77619,
		77619
	],
	"./no/lobby.json": [
		71133,
		89291
	],
	"./no/lootboxes.json": [
		10661,
		10661
	],
	"./no/loyalty.json": [
		15125,
		15125
	],
	"./no/lpAssets.json": [
		66918,
		66918
	],
	"./no/lyzer40BanksBenefitsJune2025LP.json": [
		39042,
		39042
	],
	"./no/march2025.json": [
		64045,
		64045
	],
	"./no/mobileApp.json": [
		79493,
		79493
	],
	"./no/personal.json": [
		86015,
		86015
	],
	"./no/profile.json": [
		2035,
		2035
	],
	"./no/promotions.json": [
		70407,
		70407
	],
	"./no/referralSystem.json": [
		64994,
		64994
	],
	"./no/regDragonRewards.json": [
		43961,
		43961
	],
	"./no/regDragonRewardsAugust25LP.json": [
		8336,
		8336
	],
	"./no/regRewards.json": [
		36422,
		36422
	],
	"./no/scratchGame.json": [
		24386,
		24386
	],
	"./no/security.json": [
		54558,
		54558
	],
	"./no/sharkJuly25LP.json": [
		77655,
		77655
	],
	"./no/slotsCircle.json": [
		70319,
		70319
	],
	"./no/sportsDeposit.json": [
		79889,
		79889
	],
	"./no/sunOfEgypt.json": [
		10092,
		10092
	],
	"./no/support.json": [
		44959,
		44959
	],
	"./no/turbolvlJuly25LP.json": [
		77485,
		774
	],
	"./no/validation.json": [
		53486,
		53486
	],
	"./no/verification.json": [
		6970,
		6970
	],
	"./no/vip.json": [
		28300,
		28300
	],
	"./no/vipGemCards.json": [
		81105,
		81105
	],
	"./no/welcomeApril2025.json": [
		58734,
		58734
	],
	"./no/wheel.json": [
		38033,
		38033
	],
	"./no/wheelFortuneLP.json": [
		18539,
		18539
	],
	"./no/winterJanuary.json": [
		79644,
		79644
	],
	"./no/withdraw.json": [
		27513,
		27513
	],
	"./no/wolfElvisSunBuffalo.json": [
		87679,
		87679
	],
	"./no/wolfWheelLP.json": [
		18346,
		18346
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 71539;
module.exports = webpackAsyncContext;